export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex items-start justify-between mb-6 gap-4 flex-wrap" data-testid={testId || "page-header"}>
      <div>
        <h1 className="text-2xl lg:text-3xl font-bold text-slate-900" style={{ fontFamily: "Plus Jakarta Sans" }}>
          {title}
        </h1>
        {subtitle ? <p className="text-sm text-slate-500 mt-1">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
